import RCTooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap_white.css';
import React, { useState } from 'react';
import { isMobile } from 'react-device-detect';
import { FormattedHTMLMessage } from 'react-intl';
import { ReactComponent as QuestionmarkIcon } from '../../../assets/img/svg/questionmark.svg';
import dlt from '../../../utils/default-lang';
import { TooltipIconSC } from './tooltip.styled';

function Tooltip({
  overlayInnerStyle,
  contentId,
  className,
  icon,
  placement = 'top',
  align,
  showArrow,
}) {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <RCTooltip
        placement={placement}
        overlay={
          contentId ? (
            <FormattedHTMLMessage id={contentId} defaultMessage={dlt[{ contentId }]} />
          ) : null
        }
        mouseEnterDelay={0.1}
        overlayInnerStyle={overlayInnerStyle}
        trigger={isMobile ? ['click'] : undefined}
        onVisibleChange={(visible) => {
          setVisible(visible);
        }}
        align={align}
        showArrow={showArrow}
      >
        <TooltipIconSC
          className={`tooltip-icon ${visible && 'tooltip-visible'} ${className} `}
          tooltipVisible
        >
          {icon ? icon : <QuestionmarkIcon />}
        </TooltipIconSC>
      </RCTooltip>
    </>
  );
}

export default Tooltip;
